import Service from "../../service";

const shipping = {
    getShipping(page) {
        return Service.get("/shipping-fee-history?page="+page);
    },
    createShipping(data){
        return Service.post("/shipping-fee-history" ,data);
    },
    createShippingSub(data){
        return Service.post("/shipping-fee-history-createSub" ,data);
    },
    searchCustomerShipping(page, data){
        return Service.get("/search-shipping?page="+page+
            "&customer_id="+data.customer_id+
            "&area_id="+data.area_id+
            "&province_id="+data.province_id+
            "&districts_id="+data.districts_id+
            "&sub_districts_id="+data.sub_districts_id+
            "&order="+data.order+
            "&sale_id="+data.sale_id
        );
    },
    searchCustomerSubShipping(page, data){
        return Service.get("/customer_other_search?page="+page+
            "&customer_id="+data.customer_id+
            "&area_id="+data.area_id+
            "&province_id="+data.province_id+
            "&districts_id="+data.districts_id+
            "&sub_districts_id="+data.sub_districts_id+
            "&order="+data.order+
            "&sale_id="+data.sale_id+
            "&select_all="+data.select_all
        );
    },
    searchEditShipping(page,date){
        return Service.post("/search-edit-shipping?page="+page,date);
    },
    selectAll(data){
        return Service.get("/select_all_shipping?"+
            "&customer_id="+data.customer_id+
            "&area_id="+data.area_id+
            "&province_id="+data.province_id+
            "&districts_id="+data.districts_id+
            "&sub_districts_id="+data.sub_districts_id+
            "&order="+data.order+
            "&sale_id="+data.sale_id);
    }
};
export default shipping;
